import { render, staticRenderFns } from "./jihuijiaohu.vue?vue&type=template&id=5f6175e2"
import script from "./jihuijiaohu.vue?vue&type=script&lang=js"
export * from "./jihuijiaohu.vue?vue&type=script&lang=js"
import style0 from "./jihuijiaohu.vue?vue&type=style&index=0&id=5f6175e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports